var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageTitle',{attrs:{"route":_vm.$route}}),_c('PageRowWrapper',[(_vm.activeStatus)?_c('ActiveStatusForm',{attrs:{"activeStatus":_vm.activeStatus}}):_vm._e(),(!_vm.activeStatus)?_c('LoadingPage'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }